import { render, staticRenderFns } from "./InternalChatLogItem.vue?vue&type=template&id=4fb89fe8"
import script from "./InternalChatLogItem.vue?vue&type=script&lang=js"
export * from "./InternalChatLogItem.vue?vue&type=script&lang=js"
import style0 from "./InternalChatLogItem.vue?vue&type=style&index=0&id=4fb89fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports